export enum InviteChannel {
  Sms = 'sms',
  WhatsApp = 'whatsapp',
}
